export function getDeferredChargesById(state) {
  return state.admin.deferredCharges;
}
